"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.skip_right = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var skip_right = function skip_right(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'skip-right-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M6.96967 5.46967C6.67678 5.76256 6.67678 6.23744 6.96967 6.53033L10.4393 10L6.96967 13.4697C6.67678 13.7626 6.67678 14.2374 6.96967 14.5303C7.26256 14.8232 7.73744 14.8232 8.03033 14.5303L12.0303 10.5303C12.3232 10.2374 12.3232 9.76256 12.0303 9.46967L8.03033 5.46967C7.73744 5.17678 7.26256 5.17678 6.96967 5.46967Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M13 5.25C12.5858 5.25 12.25 5.58579 12.25 6L12.25 14C12.25 14.4142 12.5858 14.75 13 14.75C13.4142 14.75 13.75 14.4142 13.75 14L13.75 6C13.75 5.58579 13.4142 5.25 13 5.25Z',
    fill: '#4B5563'
  }));
};

exports.skip_right = skip_right;